import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ColumnChartTwo } from "../../../../Constant";
import { COLUMN_CHART_2_DATA, COLUMN_CHART_2_OPTION } from "../../../../Data/Charts/GoogleChart";
import { Chart } from "react-google-charts";

const ColumnChart2 = () => {
  return (
    <Col sm="12" xl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={ColumnChartTwo} />
        <CardBody className="chart-block">
          <div className="chart-overflow" id="column-chart2">
            <Chart chartType="Bar" width="100%" height="400px" data={COLUMN_CHART_2_DATA} options={COLUMN_CHART_2_OPTION} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ColumnChart2;
